'use client'

import { Link } from '@/i18n/navigation'
import Image from 'next/image'
import { RiCloseCircleLine } from 'react-icons/ri'
import { Text } from 'rsuite'
import AdBrand from '../../../assets/images/cart/ad.png'
import styles from './styles.module.scss'

export default function Ad({ setShowAd }: { setShowAd: (e: boolean) => void }) {
  return (
    <div className={styles.rootAd}>
      <div className={styles.rootAdBox}>
        <Image src={AdBrand} alt="ad brand" className={styles.adImage} />
        <Text className={styles.adText}>
          Кешбэк 3% в приложении Uzum Bank при оплате любой картой
        </Text>
        <Link href="#" className={styles.adLink}>
          Подробнее
        </Link>
      </div>

      <RiCloseCircleLine
        className={styles.adCloseIcon}
        onClick={() => setShowAd(false)}
      />
    </div>
  )
}
